export default __webpack_public_path__ + "static/media/calbotFonts.e13af205.png";